export const Calendar = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="5" y="5" width="22" height="22" rx="1" stroke="currentColor" stroke-width="2"/>
<path d="M5 11H27" stroke="currentColor" stroke-width="2"/>
<path d="M21 8V2" stroke="currentColor" stroke-width="2"/>
<path d="M11 8V2" stroke="currentColor" stroke-width="2"/>
</svg>`;
